import React, { useEffect } from 'react'
import setBVListeners from './ReviewsTaggingSerializer'

const BazaarVoice = () => {
  useEffect(() => {
    window.$BV.configure('global', { submissionContainerUrl: 'https://www.argos.co.uk/reviews/' })
    window.$BV.ui('submission_container', { userToken: '' })
    let waitForBVLoaded = 0
    waitForBVLoaded = setInterval(() => {
      if (window.document.querySelectorAll('#BVSubmissionContainer form').length) {
        clearTimeout(waitForBVLoaded, setBVListeners())
      }
    }, 1000)
  })
  return (
    <div className='bazaarvoice-container'>
      <div className='container'>
        <div id='bazaarvoicecontent' />
        <div id='main'>
          <div id='content_1'>
            <div className='content'>
              <div id='BVSubmissionContainer' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BazaarVoice
